import { c as _c } from "react/compiler-runtime";
import { MessageCircle } from "lucide-react";
interface CompactCircleProps {
  onClick: () => void;
  label: string;
  position: string;
  showDot: boolean;
}
export function CompactCircle(t0) {
  const $ = _c(8);
  const {
    onClick,
    label,
    position,
    showDot
  } = t0;
  const t1 = `fixed ${position} z-[60]
        h-14 w-14 rounded-[9999px] bg-primary-container text-white
        chat-circle-hover transition-all duration-300
        flex items-center justify-center
        group`;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <MessageCircle className="h-6 w-6" />;
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] !== showDot) {
    t3 = showDot && <span className="absolute -top-1 -right-1 h-4 w-4 rounded-[9999px] bg-secondary border-2 border-background" />;
    $[1] = showDot;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== label || $[4] !== onClick || $[5] !== t1 || $[6] !== t3) {
    t4 = <button onClick={onClick} className={t1} aria-label={label}>{t2}{t3}</button>;
    $[3] = label;
    $[4] = onClick;
    $[5] = t1;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return t4;
}